// Global function to handle hash filtering - runs immediately
function handleHashFilter() {
  const currentHash = window.location.hash.substring(1);
  console.log('Hash detected:', currentHash);
  
  if (!currentHash) return;
  
  // Map URL handles to spirit data attributes
  const urlToSpirit = {
    'blanco': 'la-pulga-tequila-blanco',
    'reposado': 'la-pulga-tequila-reposado', 
    'anejo': 'la-pulga-tequila-anejo',
    'blanco-110': 'la-pulga-tequila-blanco-110',
    'reposado-110': 'la-pulga-tequila-reposado-110',
    'mezcal': 'la-pulga-mezcal-artesanal',
    'sotol': 'la-pulga-sotol-silver'
  };
  
  const targetSpirit = urlToSpirit[currentHash];
  console.log('Target spirit:', targetSpirit);
  
  if (!targetSpirit) return;
  
  // Wait for elements to be available
  function applyFilter() {
    const buttons = document.querySelectorAll('.filters__button');
    const recipes = document.querySelector('.recipes');
    
    if (buttons.length === 0 || !recipes) {
      console.log('Elements not ready, retrying...');
      setTimeout(applyFilter, 100);
      return;
    }
    
    console.log('Applying filter for:', targetSpirit);
    
    // Find and activate the matching button
    buttons.forEach(button => {
      if (button.dataset.spirit === targetSpirit) {
        // Remove active from all buttons
        buttons.forEach(b => b.classList.remove('active'));
        
        // Add active to target button
        button.classList.add('active');
        
        // Apply color
        const selectedColor = button.dataset.color || 'blue';
        buttons.forEach(b => {
          b.classList.remove('color-blue', 'color-brown', 'color-black', 'color-green', 'color-red', 'color-beige', 'color-cream', 'color-charcoal', 'color-dark-brown');
          b.classList.add(`color-${selectedColor}`);
        });
        
        console.log('Button activated, filtering recipes...');
        
        // Filter recipes immediately
        const hiddenClass = "recipes-hidden";
        recipes.querySelectorAll(`.recipe-listing.${hiddenClass}`).forEach(c => {
          c.classList.remove(hiddenClass)
        });
        recipes.querySelectorAll(`.recipe-listing:not(.spirit-${targetSpirit})`).forEach(c => {
          c.classList.add(hiddenClass)
        });
      }
    });
  }
  
  applyFilter();
}

// Run on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', handleHashFilter);
} else {
  handleHashFilter();
}

// Run on hash change
window.addEventListener('hashchange', handleHashFilter);

class a extends HTMLElement {
  constructor() {
    super();
    const r = this,
      i = r.querySelectorAll(".filters__button");
    
    if (console.log("recipes-header"), i && i.length > 1) {
      const s = document.querySelector(".recipes"),
        e = "recipes-hidden";
      
      i.forEach(t => {
        t.addEventListener("click", d => {
          if (t.classList.contains("active")) return;
          
          const l = t.dataset.spirit;
          const filterUrl = t.dataset.url;
          
          s.classList.add(e);
          
          setTimeout(() => {
            s.classList.remove(e)
          }, 300);
          
          const o = r.querySelector(".filters__button.active");
          o && o.classList.remove("active");
          
          t.classList.add("active");
          
          // Apply the selected spirit's color to all buttons
          const selectedColor = t.dataset.color || 'blue';
          i.forEach(button => {
            // Remove all color classes first
            button.classList.remove('color-blue', 'color-brown', 'color-black', 'color-green', 'color-red', 'color-beige', 'color-cream', 'color-charcoal', 'color-dark-brown');
            // Add the selected color class to all buttons
            button.classList.add(`color-${selectedColor}`);
          });
          
          // Update the URL without page reload
          if (filterUrl && window.history && window.history.replaceState) {
            window.history.replaceState(
              { spirit: l }, 
              '', 
              filterUrl
            );
          }
          
          setTimeout(() => {
            s.querySelectorAll(`.recipe-listing.${e}`).forEach(c => {
              c.classList.remove(e)
            });
            l != "all" && s.querySelectorAll(`.recipe-listing:not(.spirit-${l})`).forEach(c => {
              c.classList.add(e)
            })
          }, 200)
        })
      });
    }
  }
}

customElements.define("recipes-header", a);